<template>
	<Dialog v-bind:value="value" @input="$emit('input', $event)"
					title="Publisher löschen ?"
					:loading="loading"
					@ok="submit" ok-text="Löschen"
					@click:outside="close"
					@cancel="close"
	>
		Soll der Publisher <b>{{ selected ? selected.Name : null }}</b>
		wirklich gelöscht werden?
	</Dialog>
</template>

<script>
import Dialog from "../../../components/Dialog";

export default {
	name: "DeletePublisherDialog",
	components: {Dialog},
	props: ['value'],
	data: () => {
		return {
			loading: false,
		}
	},
	computed: {
		selected() {
			return this.$store.state.settings.selectedItem;
		}
	},
	methods: {
		async submit() {
			this.loading = true;
			let data;
			try {
				data = await this.$store.dispatch('settings/deletePublisher', {publisher_id: this.selected.PublisherId});
				this.loading = false;
				if (data.Status) {
					this.$root.$emit('snackbar', this.selected.Name + ' erfolgreich gelöscht.');
					this.$emit('input', false); // set v-model to false -> close dialog
					this.$emit('deleted');
				}
			} catch (e) {
				this.loading = false;
			}
		},
		close() {
			this.$store.commit('settings/resetSelected');
			this.$emit('input', false);
		}
	}
}
</script>

<style scoped>

</style>